import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-rating', 'rating-singular', 'zvaigzne');
Labels.set('ui-rating', 'rating-plural', 'zvaigznes');
